import type {Breadcrumb} from '@sentry/react';
import {stripPersonalParams} from './urlQuery';

const strip = (url: unknown) => (typeof url === 'string' ? stripPersonalParams(url) : url);

/**
 * Sentry's `beforeBreadcrumb`: removes personal query params from every URL a breadcrumb records.
 *
 * - `navigation`: Sentry wraps pushState after index.html does, so it records the URL a page
 *   navigated to before the scrub removes its personal params.
 * - `xhr` / `fetch`: request URLs never pass through the scrub at all, and some carry
 *   credentials (`gift-lookup?t=<gift code>`).
 */
export const scrubBreadcrumb = (breadcrumb: Breadcrumb): Breadcrumb => {
  if (!breadcrumb.data) {
    return breadcrumb;
  }
  if (breadcrumb.category === 'navigation') {
    breadcrumb.data = {...breadcrumb.data, from: strip(breadcrumb.data.from), to: strip(breadcrumb.data.to)};
  } else if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
    breadcrumb.data = {...breadcrumb.data, url: strip(breadcrumb.data.url)};
  }
  return breadcrumb;
};
